"use strict";

require("core-js/modules/es6.string.fixed");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("../util");

var ContentfulAssetAccessor =
/** @class */
function () {
  function ContentfulAssetAccessor(base) {
    this.base = base;
  }

  ContentfulAssetAccessor.prototype.hasBaseFields = function () {
    return !!this.base && !!this.base.fields;
  };

  ContentfulAssetAccessor.prototype.hasFileUrl = function () {
    return this.hasBaseFields() && !!this.base.fields.file && !!this.base.fields.file.url;
  };

  ContentfulAssetAccessor.prototype.url = function (defaultValue) {
    if (this.hasFileUrl()) {
      return this.base.fields.file.url;
    }

    return defaultValue;
  };

  ContentfulAssetAccessor.prototype.fluid = function (opts) {
    if (this.hasFileUrl()) {
      var url = this.base.fields.file.url;
      var imageDetails = this.base.fields.file.details.image;
      var returnObject = {
        base64: undefined,
        tracedSVG: undefined,
        aspectRatio: imageDetails && imageDetails.width / imageDetails.height,
        src: url,
        srcSet: undefined,
        srcWebp: undefined,
        srcSetWebp: undefined,
        sizes: undefined,
        presentationWidth: imageDetails && imageDetails.width,
        presentationHeight: imageDetails && imageDetails.height
      };

      if (this.base.fields.file.contentType !== 'image/svg+xml') {
        returnObject.srcSet = util_1.generateSrcSet(url, imageDetails && imageDetails.width);
      }

      return returnObject;
    }

    return util_1.createFallbackFluidImageObject(opts && opts.fallbackImage);
  };

  ContentfulAssetAccessor.prototype.fixed = function (opts) {
    if (this.hasFileUrl()) {
      var url = this.base.fields.file.url;
      var imageDetails = this.base.fields.file.details.image;
      return {
        base64: undefined,
        tracedSVG: undefined,
        aspectRatio: imageDetails && imageDetails.width / imageDetails.height,
        src: url,
        srcSet: util_1.generateSrcSet(url, imageDetails && imageDetails.width),
        srcWebp: undefined,
        srcSetWebp: undefined,
        width: imageDetails && imageDetails.width,
        height: imageDetails && imageDetails.height
      };
    }

    return util_1.createFallbackFixedImageObject(opts && opts.fallbackImage);
  };

  ContentfulAssetAccessor.prototype.title = function () {
    if (this.hasBaseFields() && this.base.fields.title) {
      return this.base.fields.title;
    }

    return undefined;
  };

  ContentfulAssetAccessor.prototype.type = function () {
    if (this.hasBaseFields() && this.base.fields.file.contentType) {
      return util_1.getAssetTypeFromMimeType(this.base.fields.file.contentType);
    }

    return undefined;
  };

  return ContentfulAssetAccessor;
}();

exports.ContentfulAssetAccessor = ContentfulAssetAccessor;